export default __webpack_public_path__ + "static/media/close.6c1b63e5.svg";